import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarDays } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full bg-dark py-24 border-b border-dark-lighter" data-id="element-195">
      <div className="max-w-4xl mx-auto px-6" data-id="element-196">
        <FadeIn data-id="element-197">
          <div className="text-center mb-16" data-id="element-198">
            <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-4" data-id="element-199">
              What Changes in <span className="text-cyan-accent" data-id="element-200">7 Days</span>
            </h2>
            <p className="text-xl text-gray-400 font-light" data-id="element-201">
              The timeline to reclaiming your mobility.
            </p>
          </div>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-cyan-accent/50 before:to-transparent" data-id="element-202">
            {/* Day 3 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-203">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-cyan-accent bg-dark text-cyan-accent shadow-[0_0_10px_rgba(0,212,255,0.5)] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-204">
                <CalendarDays className="w-5 h-5" data-id="element-205" />
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-dark-panel p-6 border border-dark-lighter" data-id="element-206">
                <div className="font-display text-xl text-cyan-accent uppercase mb-2" data-id="element-207">
                  By Day Three
                </div>
                <p className="text-gray-300 text-lg" data-id="element-208">
                  The "morning stiffness" that usually lasts an hour will vanish
                  in five minutes.
                </p>
              </div>
            </div>

            {/* Day 7 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-209">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-cyan-accent bg-dark text-cyan-accent shadow-[0_0_10px_rgba(0,212,255,0.5)] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-210">
                <CalendarDays className="w-5 h-5" data-id="element-211" />
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-dark-panel p-6 border border-dark-lighter" data-id="element-212">
                <div className="font-display text-xl text-cyan-accent uppercase mb-2" data-id="element-213">
                  By Day Seven
                </div>
                <p className="text-gray-300 text-lg" data-id="element-214">
                  You will be able to sit through a two-hour flight or meeting
                  without your leg "going to sleep" or your lower back
                  throbbing.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}